import './custom.styles.scss';
import Tabs from './Tabs/Tabs';
import {
  Cashback,
  ChangePassword,
  PromoCode,
  Safe,
  SignInHistory,
  UserInformation,
  Notifications,
  InviteFriend,
  AccountControl
} from './pages';
import Transactions from './pages/transactions/Transactions';
import Payment from '../global/payment/Payment';
import { useTranslation } from 'lb-store';

const UserPageRouter = ({ route, setRoute, navigate, close }) => {
  const { t } = useTranslation();
  switch (route) {
    case 'deposit':
    case 'withdraw':
      return (
        <Payment
          platform={'mob'}
          type={route}
          onTypeChange={(e) => setRoute(e)}
        />
      );
    case 'promo-code':
      return (
        <PromoCode navigate={navigate} setRoute={setRoute} route={route} t={t} />
      );
    case 'safe':
      return <Safe navigate={navigate} setRoute={setRoute} route={route} t={t} />;
    case 'notifications':
      return (
        <Notifications navigate={navigate} setRoute={setRoute} route={route} />
      );
    case 'cashback':
      return <Cashback navigate={navigate} setRoute={setRoute} route={route} />;
    case 'transaction-history':
      return <Transactions setRoute={setRoute} />;
    case 'auth-history':
      return <SignInHistory setRoute={setRoute} />;
    case 'personal-info':
      return <UserInformation setRoute={setRoute} t={t} />;
    case 'password-reset':
      return <ChangePassword setRoute={setRoute} />;
    case 'dis-account':
      return <AccountControl setRoute={setRoute} />;
    case 'invite-friend':
      return <InviteFriend setRoute={setRoute} />;
    default:
      return <Tabs setRoute={setRoute} navigate={navigate} close={close} />;
  }
};
export default UserPageRouter;
